// Side-effect barrel for the legacy segment subtree (WEB-8485). root.jsx creates the
// ReactTemplates.segment namespace; the rest populate its keys at module eval. Loaded once
// by ReactTemplatesShim at the React entry (root first). Order mirrors the old legacy-react.js.
import './root';
import './body';
import './contactStats';
import './events';
import './eventRow';
import './flow';
import './flowPreview';
import './flowEditor';
import './flowPopup';
import './newSegmentModal';
import './addToSegmentModal';
